import DOMPurify from 'dompurify';

// Agreement templates are admin-authored rich text rendered on customer-facing
// pages via dangerouslySetInnerHTML. Sanitize on render so a compromised or
// careless admin edit can't inject a script into a customer's browser.
const ALLOWED_TAGS = ['p', 'br', 'strong', 'em', 'b', 'i', 'ul', 'ol', 'li', 'h3', 'h4', 'a'];
const ALLOWED_ATTR = ['href', 'target', 'rel'];

export function sanitizeHtml(dirty) {
  if (!dirty) return '';
  return DOMPurify.sanitize(dirty, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
  });
}
